export function PageLoader() {
  return <div className="page-loader" role="status" aria-label="در حال بارگذاری"><span /><span /><span /></div>
}
